var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReferralRatesIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 46,
  height: 42,
  viewBox: "0 0 46 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 42,
  rx: 8,
  fill: "#E60000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.0867 31.0254L27.2451 10.9727H29.8595L18.755 31.0254H16.0867ZM16.5448 21.6998C13.5801 21.6998 12.0977 19.9209 12.0977 16.5249C12.0977 13.4793 13.607 11.1883 16.6796 11.1883C19.9139 11.1883 21.0998 13.5332 21.0998 16.6058C21.0998 19.894 19.4288 21.6998 16.5448 21.6998ZM16.5718 19.6784C18.0272 19.6784 18.3507 18.2499 18.3507 16.6058C18.3507 15.5277 18.2698 13.2097 16.6796 13.2097C15.0355 13.2097 14.8468 15.0964 14.8468 16.6058C14.8468 17.8186 14.8738 19.6784 16.5718 19.6784ZM29.3474 30.8098C26.2748 30.8098 24.9002 28.7345 24.9002 25.5001C24.9002 22.5623 26.3556 20.2983 29.4821 20.2983C32.42 20.2983 33.9024 22.158 33.9024 25.581C33.9024 28.7884 32.2852 30.8098 29.3474 30.8098ZM29.3743 28.7884C30.7489 28.7884 31.1532 27.4407 31.1532 25.5271C31.1532 23.4248 30.6411 22.3197 29.4552 22.3197C27.7033 22.3197 27.6493 24.449 27.6493 25.5271C27.6493 26.7939 27.6763 28.7884 29.3743 28.7884Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReferralRatesIcon);
export default ForwardRef;